import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Space, Table, Form, Row, Col, Checkbox , Button, Popconfirm, message, Select } from 'antd';
import {  useProjectOperator } from 'hooks';
import { TableWrapper } from 'components/molecules';
import { ColumnsType } from 'antd/lib/table/interface';
import { PlusOutlined } from '@ant-design/icons';
import { OpCode } from 'components/TableSearchBox';
import { getCodeNumberArray } from 'utils/form-utils';
import { MSG } from 'commons/constants';
import useStore from 'store';

export interface OperatorEditModallProps extends PopupProps {
    group_srl: number;
    schedule_date: string;
}

const OperatorEditModal = ({ isOpen, onClose, group_srl, schedule_date }: OperatorEditModallProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
  const [operators, setOperators] = useState<OperatorItemDto[]>([]);
  const [searchOp, setSearchOp] = useState<OperatorItemDto>();
  const [curOperator, setCurOperator] = useState<OperatorItemDto|null>();
  const [scheduleList, setScheduleList] = useState<OperatorScheculeItemDto[]>([]);
  const [deleteList, setDeleteList] = useState<OperatorItemDto[]>([]);
  const [dailyOption, setDailyOption] = useState<any[]>()
  const [scheduleDate, setScheduleDate] = useState<string>(schedule_date)
  const [isEdit, setIsEdit] = useState<boolean>(false);

   /* ======================================================
   * variables
   * ====================================================== */
   const [form] = Form.useForm();
   const auth = useStore((state) => state.auth);       
   const columns: ColumnsType<OperatorScheculeItemDto> = [
    {
      title: '강사',
      dataIndex: 'lecturer',
      key: 'lecturer',
      width: '70px',
      align: 'left',
      ellipsis: true,
    },
    {
     title: '강의시간',
     dataIndex: 'start_time',
     key: 'start_time',
     width: '120px',
     align: 'center',
     ellipsis: true,
     render: (start_time, record) => {
      return (
        <>
          {start_time + '~'+record.end_time}
        </>        
      )  
    }     
   },   
   {
     title: '장소',
     dataIndex: 'lecture_place',
     key: 'lecture_place',
     width: 'auto',
     align: 'center',
     ellipsis: true,
   },  
   {
    title: '필요인원',
    dataIndex: 'need_operater_num',
    key: 'need_operater_num',
    width: '70px',
    align: 'center',
    ellipsis: true,
  },  
   {
     title: '운영자',
     dataIndex: 'operator',
     key: 'operator',
     width: '150px',
     align: 'center',
     ellipsis: true,
   }, 
  ];
   /* ======================================================
   * events
   * ====================================================== */
   const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: OperatorScheculeItemDto[]) => {
      if (curOperator) {
        const selected = selectedRows.map((item) => {return (item.id)});
        let startTime = '';
        let endTime = '';
        selectedRows.forEach((item) => {
          if (startTime === '' || startTime > item.start_time) startTime = item.start_time;
          if (endTime === '' || endTime < item.end_time) endTime = item.end_time;
        })
        const newOp = {...curOperator, scheduleArr: selected, start_time: startTime, end_time: endTime};
        reloadScheduleList(newOp);
        setIsEdit(true);
      }
    },
    getCheckboxProps: (record: OperatorScheculeItemDto) => ({
      disabled: (!curOperator || (curOperator && curOperator.is_all_time === 'Y')), // Column configuration not to be checked
    }),
  };

  const reloadScheduleList = (oop: OperatorItemDto) => {
    setCurOperator(oop);    
    const newOps = operators.map((item) => {
      return (item.user_id === oop.user_id)?oop:item;
    })
    setOperators(newOps);      

    const newSchedule = scheduleList.map((schedule) => {
      let operator = '';
      newOps.forEach((op) => {
        if (op.is_all_time === 'Y' || op.scheduleArr.indexOf(schedule.id) >-1) {
          if (operator.length > 0) operator+=',';
          operator+=op.user_name;
        }
      })
      return {...schedule, operator}
    })
    setScheduleList(newSchedule) 
  }

  const onAllTimeChange = (e) => {
    if (curOperator) {
      if (e.target.checked) {
        const selected = scheduleList.map((item) => {return (item.id)});
        let startTime = '';
        let endTime = '';
        scheduleList.forEach((item) => {
          if (startTime === '' || startTime > item.start_time) startTime = item.start_time;
          if (endTime === '' || endTime < item.end_time) endTime = item.end_time;
        })

        const newOp = {...curOperator, is_all_time:'Y', scheduleArr:selected, start_time:startTime, end_time:endTime};
        reloadScheduleList(newOp);
      } else {
        const newOp = {...curOperator, is_all_time:'N', scheduleArr:[], start_time:'', end_time:''};
        reloadScheduleList(newOp);
      }
      setIsEdit(true);
    }
  };

  const onSaveOperator = () => {
    if (dailyInfo) {
      const dellist = deleteList.filter((del) => {
        if (operators.findIndex((op) => op.user_id === del.user_id) < 0) return del;     
      })
      
      operators.forEach((op) => {
        // 스캐줄이 없으면 삭제 처리
        if (op.scheduleArr.length === 0) {
          dellist.push(op);
        }
      });  

      dellist.forEach((del) => {
        operatorDelete({
          id: del.id,
        }) 
      });  
      
      const newop = operators.filter((op)=> op.scheduleArr.length > 0);

      newop.forEach((op) => {
          operatorUpdate({
            id: op.id,
            project_srl: dailyInfo.id,
            user_id: op.user_id,
            schedule_date: scheduleDate,
            start_time: scheduleDate + ' ' + op.start_time,
            end_time: scheduleDate + ' ' + op.end_time,
            is_all_time: op.is_all_time,
            schedule: op.scheduleArr?.map((code) => code).join(',') ||'',
          }) 
      });  
      setOperators(newop);

      message.info(MSG.SUCCESS_SAVE, 1);
      setIsEdit(false);
    }
  };

  const onSelectDaily = (value) => {

    if (isEdit) {
      alert("변경 사항이 있습니다 저장후 일자 변경 가능 합니다.");
      return;
    }
    setCurOperator(null)
    setDeleteList([]);
    setIsEdit(false);

    const ops = operatorInfo.filter((op) => op.schedule_date === value);
    const scs = scheculeInfo.filter((sc) => sc.schedule_date === value);


    const newOps = ops.map((op) => {return ({...op, scheduleArr: getCodeNumberArray(op.schedule)})});
    const newSchedule = scs.map((schedule) => {
      let operator = '';
      newOps.forEach((op) => {
        if (op.is_all_time === 'Y' || op.scheduleArr.indexOf(schedule.id) >-1) {
          if (operator.length > 0) operator+=',';
          operator+=op.user_name;
        }
      })
      return {...schedule, operator}
    })
    setScheduleList(newSchedule) 
    setOperators(newOps);  
    setScheduleDate(value);

  }  

  const onCloseCancle = () => {
    setIsEdit(false);
    onClose?.(isUpdated || isDeleted); 
  }  

  const onReload = () => {
    
  }
  /* ======================================================
   * hooks
   * ====================================================== */
  const { isSuccess, refetch, dailyInfo, operatorInfo, scheculeInfo, operatorUpdate, operatorDelete, isUpdated, isDeleted } = useProjectOperator(group_srl); 
   
  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    setCurOperator(null)
    setDeleteList([]);
    setIsEdit(false);

    if (!!dailyInfo) {
      const dates = dailyInfo.schedule_date.split(',').map((item) => {return {label:item, value: item}});
      setDailyOption(dates);
      onSelectDaily(scheduleDate);
    }
    
  }, [isSuccess, dailyInfo, operatorInfo, scheculeInfo])

  useEffect(() => {
    refetch();
  }, [isUpdated, isDeleted])
    
    return (
        <ModalWrapper open={isOpen} onCancel={onCloseCancle} width={700} title={'운영자 배정 '} closable>
            <Space direction="vertical" style={{ width: '100%' }}>
                <Form
                    form={form}
                    name="RefCode"
                    layout="horizontal"  
                    labelCol={{ flex: '100px' }}
                    style={{width:'100%', marginBottom:'20px'}}
                >
                    <Form.Item label={'프로젝트명'}>
                        <label>{dailyInfo?.project_name}</label>                  
                    </Form.Item>   
                    <Row>
                        <Col span={12}>
                            <Form.Item label={'고객사'}>
                                <label>{dailyInfo?.company_name}</label>                  
                            </Form.Item>   
                        </Col> 
                        <Col span={12}> 
                            <Form.Item label={'배정일'}>
                            <Select 
                              onSelect={(value) => onSelectDaily(value)}
                              placeholder="배정일선택 선택" 
                              value={scheduleDate}
                              options={dailyOption}/>             
                            </Form.Item>    
                        </Col>            
                    </Row>
                    <Form.Item label={'운영자'}>
                      <Space>
                        {operators.map((item, index) => {
                          return (
                            (curOperator && curOperator.user_id === item.user_id) ? (
                              <Button key={index} danger>{item.user_name}</Button>
                            ): (
                              <Button onClick={()=>setCurOperator(item)}>{item.user_name}</Button>
                            )
                          )
                        })}
                        <OpCode isAll={false} onChangeSelect={(value, option)=> {
                          setSearchOp({
                            id: 0,
                            user_id: option.value,
                            user_name: option.label,
                            schedule_date: '',
                            start_time: '',
                            end_time: '',
                            is_all_time: 'N',
                            schedule: '',
                            scheduleArr: [],
                          })                           
                        }}/>
                        <Button icon={<PlusOutlined />} onClick={
                          () => { 
                          !!searchOp 
                          && 
                          (operators.findIndex((item) => item.user_id === searchOp.user_id) < 0)
                          &&
                          setOperators([...operators, searchOp]);
                          setIsEdit(true);
                        }}
                        >
                          운영자 추가
                        </Button>
                      </Space>            
                    </Form.Item>                        
                </Form>                

                {(!!curOperator) && (
                <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                  <Space style={{marginLeft:"8px"}}>
                    <Checkbox checked={curOperator.is_all_time === 'Y'} onChange={onAllTimeChange}>종일</Checkbox>
                    <label>{curOperator.user_name}</label>
                    <label>{(curOperator.is_all_time === 'Y')?'종일배정':(!curOperator.start_time || curOperator.start_time === '')?'미배정':'배정시간 : '+curOperator.start_time+'~'+curOperator.end_time}</label>
                  </Space>
                  <Popconfirm
                    title="운영자를 배정을 삭제 하시겠습니까?"
                    onConfirm={() => {
                      setOperators(operators.filter((item) => item.user_id !== curOperator.user_id ));
                      if (curOperator.id > 0) setDeleteList([...deleteList, curOperator]);
                      setCurOperator(null);
                      setIsEdit(true);
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button size='small'>배정삭제</Button>
                  </Popconfirm>                                       
                </div>
                )}                  
                <TableWrapper isSearch={false}>
                    <Table
                        tableLayout="fixed"
                        dataSource={scheduleList}
                        pagination={false}
                        columns={columns}
                        style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
                        showSorterTooltip={false}
                        rowKey={'id'}
                        rowSelection={{
                          type: 'checkbox',
                          selectedRowKeys: curOperator?curOperator.scheduleArr:[],
                          ...rowSelection,
                        }}
                    />
                </TableWrapper>
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={()=>{onClose?.(isUpdated || isDeleted)}}>닫기</Button>
                    {(auth.login?.div === '101' || auth.login?.div === '999') && (
                      <Button onClick={onSaveOperator} type="primary">저장</Button>
                    )}
                </ButtonGroup>                  
            </Space>     
        </ModalWrapper>  
    )    
};

export default React.memo(OperatorEditModal);    